// Campos do laudo de calibracao de VALVULA DE SEGURANCA.
// Mesmo conjunto de blocos do laudo de manometro, incluindo padrao utilizado e fator k.
const valvula = {
  titulo: 'Válvula de Segurança',
  leituras: 'abertura',
  maxPontos: 5,
  secoes: [
    {
      titulo: 'Identificação da válvula',
      campos: [
        { n: 'tag', l: 'TAG', t: 'texto', span: 4, up: true, ajuda: 'Identificação da válvula dentro do cliente. Ex.: VS-01.' },
        { n: 'marca', l: 'Marca', t: 'texto', span: 5, ajuda: 'Fabricante gravado na válvula. Em branco sai NÃO CONSTA no laudo.' },
        { n: 'numero_serie', l: 'Nº de série', t: 'texto', span: 5, ajuda: 'Número de série da válvula, quando houver.' },
        { n: 'tipo_instrumento', l: 'Tipo', t: 'sel', span: 5, ajuda: 'Como a válvula é acionada.',
          o: [['alavanca', 'Alavanca'], ['bloco', 'Bloco'], ['argola', 'Argola']] },
        { n: 'conexao', l: 'Conexão', t: 'sel', span: 5, ajuda: 'Como a válvula é ligada ao equipamento.',
          o: [['rosca', 'Rosca'], ['flange', 'Flange']] },
        { n: 'bitola', l: 'Bitola', t: 'texto', span: 4, ajuda: 'Diâmetro nominal da conexão. Ex.: 1/2".' },
        { n: 'lacre', l: 'Lacre', t: 'texto', span: 4, ajuda: 'Número do lacre aplicado após o ajuste.' },
        { n: 'local_instalacao', l: 'Local de instalação', t: 'texto', span: 6, up: true, ajuda: 'Onde a válvula está instalada. Normalmente a TAG do vaso. É essa pasta que recebe o PDF no portal.' },
        { n: 'data_calibracao', l: 'Data', t: 'data', span: 4, ajuda: 'Data em que a calibração foi executada.' }
      ]
    },
    {
      titulo: 'Ajuste',
      campos: [
        { n: 'pressao_ajuste', l: 'Pressão de ajuste', t: 'num', span: 4, ajuda: 'Pressão em que a válvula deve abrir. É a referência de todas as leituras.' },
        { n: 'unidade', l: 'Unidade', t: 'sel', span: 4, ajuda: 'Unidade de pressão das leituras.',
          o: [['kgf', 'kgf/cm²'], ['bar', 'bar'], ['psi', 'psi']] },
        { n: 'fluido_ajuste', l: 'Fluido de ajuste', t: 'texto', span: 5, ajuda: 'Fluido usado na bancada para o ajuste. Ex.: ar, água.' },
        { n: 'banca', l: 'Banca de teste', t: 'texto', span: 5, ajuda: 'Identificação da bancada de pressão usada no ensaio.' },
        { n: 'validade_anos', l: 'Validade', t: 'sel', span: 3, ajuda: 'De quanto em quanto tempo a válvula deve ser recalibrada.',
          o: [[1, '1 ano'], [2, '2 anos'], [3, '3 anos'], [4, '4 anos'], [5, '5 anos']] },
        { n: 'desmontou', l: 'Desmontou?', t: 'bool', span: 3, ajuda: 'Marque se a válvula precisou ser desmontada para o serviço.' }
      ]
    }
  ],
  pontos: {
    ajuda: 'Cada linha é uma repetição do ensaio: a pressão em que a válvula abriu e a pressão em que fechou. O laudo imprime até 5 repetições.',
    colunas: [
      { n: 'abertura', l: 'Abertura', ajuda: 'Pressão em que a válvula abriu nessa repetição.' },
      { n: 'fechamento', l: 'Fechamento', ajuda: 'Pressão em que a válvula voltou a fechar nessa repetição.' }
    ]
  },
  fechamento: [
    { n: 'fator_k', l: 'Fator k', t: 'sel', span: 4, o: [[2, '2 (95%)'], [3, '3 (99%)']],
      ajuda: 'Multiplicador da incerteza padrão para chegar na incerteza expandida. k = 2 corresponde a cerca de 95% de confiança.' },
    { n: 'danificado', l: 'Danificada?', t: 'bool', span: 4, ajuda: 'Marque se a válvula chegou com dano que impeça o uso.' },
    { n: 'substituido', l: 'Substituída?', t: 'bool', span: 4, ajuda: 'Marque se a válvula foi trocada por outra no atendimento.' }
  ]
};

export default valvula;
